import { Role } from 'lib/generated/graphql';
import Head from 'next/head';
import { useState } from 'react';
import BuilderInvites from 'src/screens/invite-codes/components/BuilderInvites';
import StartupInvites from 'src/screens/invite-codes/components/FounderInvites';
import useAuth from 'src/shared-components/Auth';
import PageContainer from 'src/shared-components/Layout/PageContainer';

export enum Tabs {
  FOUNDER_INVITES = 'Founder Invites',
  BUILDER_INVITES = 'Builder Invites',
}

const InviteCodes = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState(Tabs.FOUNDER_INVITES);

  return (
    <div>
      <Head>
        <title>Huddle App - Invite Codes</title>
        <meta name="description" content="Generated by create next app" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <PageContainer title="Invite Codes">
        <>
          {user?.role === Role.Customer ? null : (
            <div className="flex gap-x-10 border-b">
              {Object.keys(Tabs).map(tab => {
                const onClick = () => setActiveTab(Tabs[tab as keyof typeof Tabs]);
                return (
                  <a
                    type="button"
                    key={tab}
                    className={`cursor-pointer text-2xl sm:text-[28px] font-medium ${
                      activeTab === Tabs[tab as keyof typeof Tabs]
                        ? 'text-black border-b-4 border-black pb-4'
                        : 'text-gray-400'
                    }`}
                    onClick={onClick}
                  >
                    {Tabs[tab as keyof typeof Tabs]}
                  </a>
                );
              })}
            </div>
          )}
          {activeTab === Tabs.BUILDER_INVITES && <BuilderInvites user={user} />}
          {activeTab === Tabs.FOUNDER_INVITES && <StartupInvites user={user} />}
        </>
      </PageContainer>
    </div>
  );
};

export default InviteCodes;
